export function loadTabsConsultaRequest(IdContrato) {
  return {
    type: '@proposta/LOAD_TABS_CONSULTA_REQUEST',
    payload: { IdContrato },
  };
}

export function loadTabsConsultaSuccess(tabs) {
  return {
    type: '@proposta/LOAD_TABS_CONSULTA_SUCCESS',
    payload: { tabs },
  };
}

export function loadTabsAnaliseRequest(IdContrato, reanalise) {
  return {
    type: '@proposta/LOAD_TABS_ANALISE_REQUEST',
    payload: { IdContrato, reanalise },
  };
}

export function loadTabsAnaliseSuccess(tabs) {
  return {
    type: '@proposta/LOAD_TABS_ANALISE_SUCCESS',
    payload: { tabs },
  };
}

export function setCurrentFila(currentFila) {
  return {
    type: '@proposta/SET_CURRENT_FILA',
    payload: currentFila
  };
}
